/**
 * Definiert das Modell für einen Klickbereich in einer Hotspot-Aufgabe
 * @class service_v3sMapareaElement
 * @memberOf v3sWbtPlayerApp:exercise:hotspot
 */
angular.module('v3sWbtPlayerApp').factory('v3sMapareaElement', ['$timeout', 'v3sExerciseElement', function ($timeout, v3sExerciseElement) {

    /**
     * Konstruktor, setzt die Maße und verknüpft das Element mit dem Exercise Service.
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
     * @param {number} id
     * @param {boolean} isCorrectAnswer - gibt an, ob diese Fläche eine korrekte Antwort darstellt
     * @param {number} width
     * @param {number} height
     * @param {number} left
     * @param {number} top
     */
    var v3sMapareaElement = function (id, isCorrectAnswer, width, height, left, top) {
        this.id = id;
        this.isCorrectAnswer = isCorrectAnswer;
        this.userAnswer = [];
        this.clicks = [];
        this.width = parseInt(width);
        this.height = parseInt(height);
        this.left = parseInt(left);
        this.top = parseInt(top);
        this.status = this.isCorrectAnswer ? this.STATUS.NO_ANSWER : this.STATUS.SILENT_CORRECT;
        this.timeout = null;
        this.load();
    };

    // Erstelle ein neues v3sExerciseElement
    v3sMapareaElement.prototype = new v3sExerciseElement();


    /**
     * Prüfe, ob diese Koordinate korrekt ist
     *
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
     * @param {number} x x-Koordinate relativ zur Hotspot-Aufgabe
     * @param {number} y y-Koordinate relativ zur Hotspot-Aufgabe
     *
     * @return {boolean} true, wenn im Klickbereich, sonst false
     */
    v3sMapareaElement.prototype.isCorrect = function (x, y) {
        return x >= this.left && x <= (this.left + this.width) &&
               y >= this.top && y <= (this.top + this.height);
    };

    /**
     * Setzt die Nutzerantwort.
     *
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
     * @param {number} x x-Koordinate relativ zur Hotspot-Aufgabe
     * @param {number} y y-Koordinate relativ zur Hotspot-Aufgabe
     * @param {Object} clickelement das Element, das den Klick darstellt
     */
    v3sMapareaElement.prototype.setUserAnswer = function (x, y, clickelement) {
        var self = this;

        var removedIndex = -1;
        if (!!this.timeout) {
            removedIndex = this.getAnswerIndex(x, y);
            this.removeLastAnswer();
        }

        if (x >= 0 && y >= 0 && removedIndex < 0) {
            var answerIndex = this.getAnswerIndex(x, y);
            //Neuer Klick
            if (answerIndex < 0) {

                this.userAnswer.push({ x: x, y: y });
                //Auf Korrekte Maparea
                if (this.isCorrectAnswer) {
                    this.status = this.STATUS.CORRECT;

                    //Auf Falsche Maparea
                } else {
                    this.status = this.STATUS.FALSE;
                }

                this.addClick(clickelement);

                //Speichern
                this.save();

                //Klick war vorhanden
            } else {
                //Löschen der Anwort
                this.userAnswer.splice(answerIndex, 1);

                //Klick löschen
                angular.forEach(self.clicks, function (click, $key) {
                    if (click[0] === clickelement) {
                        self.clicks.splice($key, 1)[0].remove();
                    }
                });

                //Falls keine Antwort mehr gegeben ist, muss der Status sich ändern
                if (this.userAnswer.length === 0) {

                    if (this.isCorrectAnswer) {
                        this.status = this.STATUS.FALSE;

                    } else {
                        this.status = this.STATUS.SILENT_CORRECT;
                    }
                    this.save();
                }
            }
        }
        self.answerAutoRemoved = false;
    };

    /**
    * Prüft ob schon eine Antwort mit diesen Koordinaten existiert
    *
    * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
    *
    * @param {number} x x-Koordinate relativ zur Hotspot-Aufgabe
    * @param {number} y y-Koordinate relativ zur Hotspot-Aufgabe
    * @return {number} Index der vorhandenen Antwort oder -1
    */
    v3sMapareaElement.prototype.getAnswerIndex = function (x, y) {
        var self = this;
        var index = -1;
        angular.forEach(self.userAnswer, function (answer, $index) {
            if (answer.x === x && answer.y === y) {
                index = $index;
            }
        });
        return index;
    };

    /**
     * Handelt es sich um eine korrekte Antwort?
     *
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
     *
     * @return {boolean} true, wenn es eine korrekte antwort ist
     */
    v3sMapareaElement.prototype.hasCorrectAnswer = function () {
        return this.isCorrectAnswer;
    };

    /**
     * Holt die Nutzerantwort
     *
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
     *
     * @return {boolean} true, wenn der Bereich ausgewählt wurde, sonst false
     */
    v3sMapareaElement.prototype.getUserAnswer = function () {
        return this.userAnswer;
    };

    /**
     * Fügt ein CLickElement hinzu, damit diese später aufgeräumt werden können
     *
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
     * @param {object} click ein Klick-Element
     *
     */
    v3sMapareaElement.prototype.addClick = function (click) {
        this.clicks.push(click);
    };

    /**
    * Setzt Timeout zum Löschen des Elements
    * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
    */
    v3sMapareaElement.prototype.setTimeoutToDelete = function () {
        if (!this.hasCorrectAnswer() && this.userAnswer.length > 0) {
            var self = this;
            self.timeout = $timeout(function () {
                self.removeLastAnswer(true);
            }, 3000);
        }
    };

    /**
    * Löscht letzte falsche Antwort
    * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sMapareaElement
    */
    v3sMapareaElement.prototype.removeLastAnswer = function (answerAutoRemoved) {
        if (!this.hasCorrectAnswer() && this.userAnswer.length > 0) {
            if (!!this.timeout) {
                $timeout.cancel(this.timeout);
                this.timeout = null;
            }

            this.answerAutoRemoved = !!answerAutoRemoved;
            this.setUserAnswer(this.userAnswer[0].x, this.userAnswer[0].y);
        }
    };

    return v3sMapareaElement;
}]);